/* ***** ----------------------------------------------- ***** **
** ***** Flexslider JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power2 */
(function($){
	'use strict';

	Main.modules.flexslider = function() {

		var $body = $('body'),
			$homeFeaturedMainNext = $('.js-home_featured_main_next'),
			$homeFeaturedMainPrevious = $('.js-home_featured_main_previous'),
			$homeFeaturedMainSlider = $('.c-home_featured_main-slider'),
			$homeFeaturedMainSliderPagination = $('.c-home_featured_main-slider_pagination'),
			$homeFeaturedMusicNext = $('.js-home_featured_music_next'),
			$homeFeaturedMusicPrevious = $('.js-home_featured_music_previous'),
			$homeFeaturedMusicSlider = $('.c-home_featured_music-slider'),
			$homeFeaturedMusicSliderSlide = $('.c-home_featured_music-slider li'),
			$homeFeaturedVideosNext = $('.js-home_featured_videos_next'),
			$homeFeaturedVideosPrevious = $('.js-home_featured_videos_previous'),
			$homeFeaturedVideosSlider = $('.c-home_featured_videos-slider'),
			$featuredEventsNext = $('.js-featured_events_next'),
			$featuredEventsPrevious = $('.js-featured_events_previous'),
			$featuredEventsSlider = $('.c-featured_events-slider'),
			$trendingNext = $('.js-trending_next'),
			$trendingPrevious = $('.js-trending_previous'),
			$trendingSlider = $('.o-trending-slider'),
			$trendingSliderSlide = $('.o-trending-slider li'),
			staggerDuration = 0.8,
			staggerEase = Power2.easeOut,
			staggerLength = 200,
			staggerOffset = 0.05,
			utilities = Main.modules.utilities(),
			isMobileWidth = utilities.isMobileWidth(),
			isMediumWidth = utilities.isMediumWidth(),
			isDesktopWidth = utilities.isDesktopWidth(),
			homeFeaturedMainSliderHeight,
			homeFeaturedMusicSliderItemWidth,

			homeFeaturedMainSlider = function() {

				$homeFeaturedMainSlider.flexslider({
					animation: 'slide',
					easing: 'easeInOutCubic',
					animationSpeed: 450,
					directionNav: false,
					useCSS: false,
					manualControls: '.c-home_featured_main-slider_pagination li:not(:last-child)',
					start: function() {
						$homeFeaturedMainSlider.addClass('c-home_featured_main-slider--ready');

						homeFeaturedMainSliderSetHeight();
					}
				});

				$homeFeaturedMainPrevious.on('click', function() {
					$homeFeaturedMainSlider.flexslider('prev');
				});

				$homeFeaturedMainNext.on('click', function() {
					$homeFeaturedMainSlider.flexslider('next');
				});
				
			},

			homeFeaturedMainSliderSetHeight = function() {

				// If viewed on a tablet, get the height of the slider and set each item to that height
				// Prevents text from overflowing and forces the image to display at full height
				if ($body.hasClass('home')) {
					$homeFeaturedMainSlider.find('li').css('height', '');

					if (isMediumWidth) {
						homeFeaturedMainSliderHeight = $homeFeaturedMainSlider.height();
						$homeFeaturedMainSlider.find('li').css('height', homeFeaturedMainSliderHeight);
					} 
				}

			},

			calculateHomeFeaturedMainSliderNavTop = function() {

				// Calculate and set the position of the pagination due to the slider being proportional on mobile
				var windowWidth = $(window).width(),
					imageHeight = windowWidth * 7 / 10,
					topPosition = imageHeight - 33;

				if (isMobileWidth) {
					$homeFeaturedMainSliderPagination.css('top', topPosition + 'px');
				} else {
					$homeFeaturedMainSliderPagination.css('top', '');
				}

			},

			homeFeaturedMusicSlider = function() {

				if (isMobileWidth) {
					homeFeaturedMusicSliderItemWidth = 2;
				} else {
					homeFeaturedMusicSliderItemWidth = 8;
				}

				$homeFeaturedMusicSlider.flexslider({
					animation: 'slide',
					easing: 'easeInOutCubic',
					animationSpeed: 450,
					slideshow: false,
					directionNav: false,
					controlNav: false,
					useCSS: false,
					itemWidth: 200,
					itemMargin: homeFeaturedMusicSliderItemWidth,
					start: function() {
						$homeFeaturedMusicSlider.addClass('c-home_featured_music-slider--ready');

						TweenMax.staggerFrom($homeFeaturedMusicSliderSlide, staggerDuration, {
							x: staggerLength,
							ease: staggerEase
						}, staggerOffset);
					}
				});

				$homeFeaturedMusicPrevious.on('click', function() {
					$homeFeaturedMusicSlider.flexslider('prev');
				});

				$homeFeaturedMusicNext.on('click', function() {
					$homeFeaturedMusicSlider.flexslider('next');
				});
				
			},

			homeFeaturedVideosSlider = function() {

				if (isDesktopWidth) {

					$homeFeaturedVideosSlider.flexslider({
						animation: 'slide',
						easing: 'easeInOutCubic',
						direction: 'vertical',
						animationSpeed: 450,
						slideshow: false,
						directionNav: false,
						controlNav: false,
						useCSS: false,
						start: function() {
							
						}
					});

					$homeFeaturedVideosPrevious.on('click', function() {
						$homeFeaturedVideosSlider.flexslider('prev');
					});

					$homeFeaturedVideosNext.on('click', function() {
						$homeFeaturedVideosSlider.flexslider('next');
					});

				}
				
			},

			featuredEventsSlider = function() {

				$featuredEventsSlider.flexslider({
					easing: 'easeInOutCubic',
					animationSpeed: 450,
					controlNav: false,
					directionNav: false,
					useCSS: false,
					start: function() {
						$featuredEventsSlider.addClass('c-featured_events-slider--ready');
					}
				});

				$featuredEventsPrevious.on('click', function() {
					$featuredEventsSlider.flexslider('prev');
				});

				$featuredEventsNext.on('click', function() {
					$featuredEventsSlider.flexslider('next');
				});
				
			},

			trendingSlider = function() {

				$trendingSlider.flexslider({
					animation: 'slide',
					easing: 'easeInOutCubic',
					animationSpeed: 450,
					slideshow: false,
					directionNav: false,
					controlNav: false,
					useCSS: false,
					itemWidth: 270,
					itemMargin: 5,
					start: function() {
						$trendingSlider.addClass('o-trending-slider--ready');

						TweenMax.staggerFrom($trendingSliderSlide, staggerDuration, {
							x: staggerLength,
							ease: staggerEase
						}, staggerOffset);
					}
				});

				$trendingPrevious.on('click', function() {
					$trendingSlider.flexslider('prev');
				});

				$trendingNext.on('click', function() {
					$trendingSlider.flexslider('next');
				});
				
			};

		return {
			init: function() {
				if ($body.hasClass('home')) {

					homeFeaturedMainSlider();
					calculateHomeFeaturedMainSliderNavTop();
					homeFeaturedMusicSlider();
					homeFeaturedVideosSlider();
					featuredEventsSlider();

				} else if ($body.hasClass('category-news')) {

					featuredEventsSlider();

				} else if ($body.hasClass('category-videos')
					|| $body.hasClass('category-music')) {

					trendingSlider();

				}
			},
			homeFeaturedMainSlider: homeFeaturedMainSlider,
			homeFeaturedMainSliderSetHeight: homeFeaturedMainSliderSetHeight,
			homeFeaturedMusicSlider: homeFeaturedMusicSlider,
			calculateHomeFeaturedMainSliderNavTop: calculateHomeFeaturedMainSliderNavTop,
			homeFeaturedVideosSlider: homeFeaturedVideosSlider,
			featuredEventsSlider: featuredEventsSlider,
			trendingSlider: trendingSlider
		}
		
	};

})(jQuery);